import { Controller } from '@hotwired/stimulus'
import throttle from 'lodash.throttle'

export default class SubmitActionsSnackbarController extends Controller {
  static targets = ['snackbar', 'container']
  static values = { throttleInterval: { type: Number, default: 10 } }

  connect = () => {
    this.resizeContainerTarget()

    this.throttledSetSnackbarPosition = throttle(this.setSnackbarPosition, this.throttleIntervalValue)
    this.throttledResizeContainerTarget = throttle(this.resizeContainerTarget, this.throttleIntervalValue)

    document.addEventListener('scroll', this.throttledSetSnackbarPosition)
    document.addEventListener('turbo:morph', this.throttledSetSnackbarPosition)
    window.addEventListener('resize', this.throttledResizeContainerTarget)
    window.addEventListener('turbo:morph', this.throttledResizeContainerTarget)
  }

  disconnect = () => {
    if (this.throttledSetSnackbarPosition) {
      document.removeEventListener('scroll', this.throttledSetSnackbarPosition)
      document.removeEventListener('turbo:morph', this.throttledSetSnackbarPosition)
    }

    if (this.throttledResizeContainerTarget) {
      window.removeEventListener('resize', this.throttledResizeContainerTarget)
      window.removeEventListener('turbo:morph', this.throttledResizeContainerTarget)
    }
  }

  resizeContainerTarget = () => {
    this.containerTarget.style.height = `${this.snackbarTarget.getBoundingClientRect().height}px`
  }

  setSnackbarPosition = () => {
    const windowHeight = window.innerHeight || document.documentElement.clientHeight
    const { bottom: containerBottom } = this.containerTarget.getBoundingClientRect()

    if (containerBottom <= windowHeight) {
      this.snackbarTarget.classList.add('snackbar-static')
    } else {
      this.snackbarTarget.classList.remove('snackbar-static')
    }

    if (window.scrollY >= windowHeight * 0.2) {
      this.snackbarTarget.classList.add('snackbar-visible')
    }
  }
}
